import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslocoService } from '@jsverse/transloco';
import { ENTITY_ACTION_SUCCESS_HANDLER } from '@vasta/shared-store';
import { MessageService } from '@openng/optimus-ui/api';

@Component({
  imports: [RouterModule],
  selector: 'app-root',
  templateUrl: './app.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: ENTITY_ACTION_SUCCESS_HANDLER,
      useFactory:
        (messages: MessageService, transloco: TranslocoService) => () => {
          messages.add({
            severity: 'success',
            summary: transloco.translate('common.actions.savedSuccess'),
            life: 3000,
          });
        },
      deps: [MessageService, TranslocoService],
    },
  ],
})
export class App {}
